// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__-F3W1","filesListContainer":"PosDisputesFiles_filesListContainer__3gkK6","filesButton":"PosDisputesFiles_filesButton__1qBPF"};